var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"code"}},[(_vm.code === undefined)?_c('InlineLoading'):(_vm.code)?_c('div',[_c('h1',[_vm._v(_vm._s(_vm.code))]),_c('p',{staticClass:"hint"},[_vm._v("请将手机号和上方礼品码提供给店员")])]):_c('p',[_vm._v("无法查看礼品码")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }